import { render } from "./auto-complete.vue?vue&type=template&id=4c65df86&scoped=true"
import script from "./auto-complete.vue?vue&type=script&lang=js"
export * from "./auto-complete.vue?vue&type=script&lang=js"

import "./auto-complete.vue?vue&type=style&index=0&id=4c65df86&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c65df86"]])

export default __exports__